import React from 'react'
import PropTypes from 'prop-types'
import { Controller, useForm } from 'react-hook-form'
import SydModal from '../../../commonDesign/SydModal'
import SydInput from '../../../commonDesign/SydInput'
import SydLabel from '../../../commonDesign/SydLabel'
import SaveCancelButtons from '../../../molecules/SaveCancelButtons'
import {
  useInsertAdvisorPermissionGroupMutation,
  useInsertWealthOwnerPermissionGroupMutation
} from '../../../../api/users'

const PermissionGroupModal = ({ open, handleClose, permissionType }) => {
  const { mutateAsync: createAdvisorPermissionGroup, isLoading } = useInsertAdvisorPermissionGroupMutation()
  const { mutateAsync: createWealthOwnerPermissionGroup } = useInsertWealthOwnerPermissionGroupMutation()
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      name: '',
      description: '',
      userType: ''
    }
  })
  const onSubmit = async (data) => {
    const command = {
      name: data.name,
      description: data.description,
      assignableToUserType: permissionType
    }
    const result = permissionType === 1 ? await createWealthOwnerPermissionGroup(command) : await createAdvisorPermissionGroup(command)
    if (result) {
      form.reset()
      handleClose()
    }
  }
  return (
    <SydModal
      open={open}
      onClose={handleClose}
      title='New Permission Group'
    >
      <div className='flex flex-col gap-sm'>
        <Controller
          control={form.control}
          name='name'
          rules={{ required: true }}
          render={({ field }) => (
            <SydLabel label='Permission Group Name' required>
              <SydInput placeholder='Permission Group Name' {...field} />
            </SydLabel>
          )}
        />
        <Controller
          control={form.control}
          name='description'
          rules={{ required: true }}
          render={({ field }) => (
            <SydLabel label='Description' required>
              <SydInput placeholder='Description' {...field} />
            </SydLabel>
          )}
        />
      </div>
      <div className='flex justify-center gap-sm'>
        <SaveCancelButtons
          onSave={form.handleSubmit(onSubmit)}
          onCancel={handleClose}
          isSubmitting={isLoading}
        />
      </div>
    </SydModal>
  )
}

PermissionGroupModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  permissionType: PropTypes.number
}

export default PermissionGroupModal
